import React from 'react';
import { ProjectPreviewModalContextType } from './types';

const ProjectPreviewModalContext = React.createContext<
  ProjectPreviewModalContextType | undefined
>(undefined);

export default ProjectPreviewModalContext;
